var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { getCenterAndRadius } from '@/components/maps/Types.tsx';
import { mapSummaryToToiletDetails, } from '@/components/toilet/data';
import useAppComponents from '@/hooks/useAppComponents';
import { draftCameraRegionAtom, toiletLayerActiveAtom, } from '@/screens/SearchScreen/atoms';
export default function useToiletLayerQuery() {
    const { toiletApi } = useAppComponents();
    const toiletLayerActive = useAtomValue(toiletLayerActiveAtom);
    const draftCameraRegion = useAtomValue(draftCameraRegionAtom);
    const { data } = useQuery({
        queryKey: [
            'toilet-layer',
            toiletLayerActive,
            draftCameraRegion
                ? {
                    ne: draftCameraRegion.northEast,
                    sw: draftCameraRegion.southWest,
                }
                : null,
        ],
        enabled: toiletLayerActive && draftCameraRegion != null,
        staleTime: 30000,
        placeholderData: previousData => previousData,
        queryFn: (_a) => __awaiter(this, [_a], void 0, function* ({ signal }) {
            var _b, _c;
            if (!draftCameraRegion) {
                return [];
            }
            const { center, radius } = getCenterAndRadius(draftCameraRegion);
            const response = yield toiletApi.searchToilets({
                currentLocation: {
                    lat: center.latitude,
                    lng: center.longitude,
                },
                distanceMetersLimit: Math.round(radius),
            }, { signal });
            return (_c = (_b = response === null || response === void 0 ? void 0 : response.data.items) === null || _b === void 0 ? void 0 : _b.map(mapSummaryToToiletDetails)) !== null && _c !== void 0 ? _c : [];
        }),
    });
    return data !== null && data !== void 0 ? data : [];
}
